import { exportEntitiesCSV } from 'services/verticalsTablesApi'
import { downloadCSV } from 'utils/downloadCSV'
import { generateCompleteFileName } from 'utils/fileNameGenerator'

export const onCSVExport = async (
  zoneEndpoint: string,
  source: { includes: string[] },
  type: string,
  csvFileName: string,
  searchValue: string,
  trackEvent?: (event: { category: string; action: string }) => void,
  selectedIds?: string[],
  sorting?: {
    desc: boolean
    id: string
  }[],
  currencyContext?: any,
): Promise<void> => {
  try {
    let entityCSV
    let finalFileName: string

    const baseFileName = generateCompleteFileName({
      vertical: csvFileName.toLowerCase().replace(/\s+/g, ''),
      exportType: 'main',
    })

    if (selectedIds && selectedIds.length > 0) {
      entityCSV = await exportEntitiesCSV(
        zoneEndpoint,
        source,
        type,
        selectedIds,
        undefined,
        undefined,
        currencyContext,
      )
      finalFileName = `${baseFileName}_Selected_${selectedIds.length}_entities`
    } else {
      entityCSV = await exportEntitiesCSV(zoneEndpoint, source, type, undefined, searchValue, sorting, currencyContext)
      finalFileName = baseFileName
    }

    downloadCSV(entityCSV, finalFileName)
    trackEvent?.({ category: 'Export', action: 'User requested for entity CSV' })
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
